<template>
  <form class="login-form form" @keypress.enter.prevent="onSubmit(fData)">
    <div class="field">
      <label for="email" class="label">E-mail</label>
      <div class="control">
        <input
          id="email"
          type="email"
          class="input"
          v-model="fData.email"
          :disabled="disabledFields.email"
        >
      </div>
    </div>
    <div class="field">
      <label for="password" class="label">Senha</label>
      <div class="control">
        <input
          id="password"
          type="password"
          class="input"
          v-model="fData.password"
          :disabled="disabledFields.password"
        >
      </div>
    </div>
    <div class="field has-text-centered">
      <button
        class="button is-primary"
        :class="{ 'is-loading': isLoading }"
        :disabled="isDisabled || $v.fData.$invalid"
        @click.prevent="onSubmit(fData)"
      >
        {{ButtonLabel || 'Login'}}
      </button>
    </div>
  </form>
</template>

<script>
import FormMixin from './FormMixin'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'loginForm',
  mixins: [FormMixin],
  data () {
    return {
      fData: {
        email: '',
        password: ''
      }
    }
  },
  validations: {
    fData: {
      email: { required, email },
      password: { required }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/LoginForm.vue